import type * as HeartbeatBundle from '@foundation-player/plugin-heartbeat';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createHeartbeatPlugin: PluginFactoryFunction = (builderConfig) => {
  const heartbeatPackage = PackageName.PluginHeartbeat;

  return [
    [heartbeatPackage],
    () => {
      const heartbeatGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[heartbeatPackage];

      return [
        new (resolveByPackageNameOrThrow<typeof HeartbeatBundle>(heartbeatPackage).HeartbeatPlugin)(
          builderConfig.pluginConfigs[heartbeatGlobalName] as HeartbeatBundle.PluginConfig,
        ),
      ];
    },
  ];
};
